import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { SET_COURSE_DECLARATION_INFO } from "../../../Redux/Reducers/DeclarationCourseReducers";
import { BrandContent } from "../../../Components/shared";
import ButtonField from "../../../Components/Ui/ButtonField";
import { pictureCongrat } from "../../../Utils/Images";
import { getActiveBrandConfig, getActiveClientBrandConfig, getActivePrestationBrandConfig } from "../../../config/environment.config";
import IndexStep from "../IndexStep";
import { useDeclarationContexte } from "../../../Contexts/DeclarationContexte";
import QuoteViewer from "../../../Components/App/Courses/QuoteViewer";

const FinishStep = () => {
    const { generalStep } = useDeclarationContexte()
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const cours = generalStep?.cours
    const declaredCourseId = generalStep?.declaredCourseId

    const handleNext = async () => {
        navigate(`/${getActiveBrandConfig()}/tableau-de-bord/${getActivePrestationBrandConfig()}`, { state: 9 })
        dispatch({
            type: SET_COURSE_DECLARATION_INFO,
            payload: null,
        });
    }

    const displayBody = () => {
        return (
            <div>
                <div className="flex items-center overflow-hidden">
                    <div className=' hidden  md:block w-1/2'>
                        <img src={pictureCongrat} alt="" />
                    </div>
                    <BrandContent
                        tag="div"
                        children={<>
                            <BrandContent
                                tag="p"
                                children={<>
                                    Votre {getActivePrestationBrandConfig()} a été validé avec succès. Il est désormais disponible dans votre tableau de bord, prêt à être consulté et géré. Vous pouvez dès à présent y accéder pour vérifier les détails ou effectuer toute autre action nécessaire. Merci de votre confiance et {getActivePrestationBrandConfig("", "bon ", "bonne ")} !
                                </>}
                                type="description"
                            />
                            {/* P2 – notification discrète : le devis généré automatiquement */}
                            {declaredCourseId && (
                                <>
                                    <BrandContent
                                        tag="p"
                                        children={<>
                                            Votre devis a été généré automatiquement. Il est disponible dans vos documents et dans l'espace de votre {getActiveClientBrandConfig()}.
                                        </>}
                                        type="description"
                                        className="italic"
                                    
                                    />
                                </>
                            )}
                        </>}
                        type="description"
                        className=" md:w-1/2 flex flex-col justify-center px-4 gap-y-4"
                    />
                </div>
                <div className="flex flex-wrap justify-center  w-full p-4 gap-y-4">
                    {declaredCourseId && <QuoteViewer courseId={declaredCourseId} />}
                    <ButtonField
                        variant="contained"
                        onClick={() => handleNext()}
                        label="Tableau de bord"
                        endIcon={<DashboardIcon />}
                        className="w-full "
                    />
                </div>
            </div>
        )
    }

    return <IndexStep
        title={`Félicitations, déclaration ${cours ? `de plusieurs ${getActivePrestationBrandConfig("s")}` : `de ${getActivePrestationBrandConfig(" ponctuelle", "", "", " ponctuel")}`} validée ! 🥳`}
        body={displayBody()}
        isHere={true}
        value={6}
        step={5}
        generalStep={generalStep}
    />

};

export default FinishStep;